import { inject, Injectable, Signal } from '@angular/core';
import { FeatureToggleManagerService } from './feature-toggle-manager.service';
import { FeatureToggles } from '../shared/constants';
import { GrowthBookValue } from '@lentau/core/growth-book/shared';

/**
 * @deprecated тоглы складываем ближе к домену где используем
 */
@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  private featureToggleManagerService: FeatureToggleManagerService = inject(FeatureToggleManagerService);

  public isPickUpEditingMode(): Signal<boolean> {
    return this.featureToggleManagerService.checkParams([FeatureToggles.EXP_EDITING_CNC], GrowthBookValue.Test);
  }

  public isAboutOrderPopupMode(): Signal<boolean> {
    return this.featureToggleManagerService.checkParams([FeatureToggles.POPUP_ABOUT_ORDER], GrowthBookValue.Test);
  }

  public isE2EMode(): Signal<boolean> {
    return this.featureToggleManagerService.checkParams([FeatureToggles.E2E]);
  }

  public isDeliveryBdPromocode(): Signal<boolean> {
    return this.featureToggleManagerService.checkParams([FeatureToggles.DELIVERY_BD_PROMOCODE], GrowthBookValue.Test_1);
  }

  public isHideDeliveryBdPromocode(): Signal<boolean> {
    return this.featureToggleManagerService.checkParams([FeatureToggles.DELIVERY_BD_PROMOCODE], GrowthBookValue.Test_2);
  }
}
